import { drypApi } from "@/services/drypApi";
import { lensApi } from "@/services/lensApi";
import { getSearchParamForRequest } from "@/utils/filters";

export interface CreateUserRequest {
	email: string;
	userName: string;
	password: string;
	roleName: string;
}

export interface UpdateUserRequest {
	email: string;
	userName: string;
	roleName: string;
}

interface deleteUserGroupRequest {
	idUserGroup: Dryp.UserGroupId;
}

export interface User {
	id: string;
	userName: string;
	email: string;
	roleName: string;
}
export type GetUsersResponse = Dryp.ApiList<User>;

export interface UserOrganizationAccess {
	organizationId: Dryp.OrganizationId;
	organizationName: string;
	roleName: string;
	primaryOrganization: boolean;
}

export interface SwitchOrganizationResponse {
	token: string;
	refreshToken: string;
}

export const user = {
	getUsers: async (
		pagination: Dryp.PaginationQuery,
		sort?: Dryp.SortQuery,
		search?: string,
	): Promise<GetUsersResponse> => {
		return lensApi.get<GetUsersResponse>(`/users`, {
			params: { ...pagination, ...sort, ...getSearchParamForRequest(search) },
		});
	},
	getAuthUser: async (): Promise<{ organizations: UserOrganizationAccess[] }> => {
		return lensApi.get<{ organizations: UserOrganizationAccess[] }>(`/user`);
	},
	switchOrganization: async (organizationId: Dryp.OrganizationId): Promise<SwitchOrganizationResponse> => {
		return lensApi.post<SwitchOrganizationResponse>(`/user/switch-organization`, { organizationId });
	},
	createUser: async (payload: CreateUserRequest): Promise<void> => {
		return lensApi.post<void>(`/users`, payload);
	},
	updateUser: async (id: string, payload: UpdateUserRequest): Promise<void> => {
		return lensApi.put<void>(`/users/${id}`, payload);
	},
	deleteUserGroup: async ({ idUserGroup }: deleteUserGroupRequest): Promise<boolean | null> => {
		return drypApi.delete<boolean | null>(`/api/UserGroups/DeleteGroup/${idUserGroup}`);
	},
};
